export const cooperativeEs = {
  cooperative: {
    // Member Management
    searchMembers: "Buscar Miembros",
    searchPlaceholder: "Buscar por nombre, email o código de miembro...",
    filters: "Filtros",
    memberSince: "Miembro desde",
    parcels: "parcelas",
    ndviAverage: "NDVI Promedio",
    performanceScore: "Puntuación de Rendimiento",
    activeAlerts: "Alertas Activas",
    viewDetails: "Ver Detalles",
    contact: "Contactar",
    noMembersFound: "No se encontraron miembros con tu búsqueda.",
    unknownMember: "Miembro Desconocido",
    active: "Activo",

    // Communication Hub
    emailSent: "Emails Enviados",
    smsSent: "SMS Enviados",
    openRate: "Tasa de Apertura",
    emailEngagement: "Engagement de email",
    responseRate: "Tasa de Respuesta",
    memberResponses: "Respuestas de miembros",
    thisMonth: "Este mes",
    composeMessage: "Redactar Mensaje",
    messageHistory: "Historial de Mensajes",
    templates: "Plantillas",
    sendMassCommunication: "Enviar Comunicación Masiva",
    selectRecipients: "Seleccionar Destinatarios",
    allMembers: "Todos los Miembros",
    withActiveAlerts: "Con Alertas Activas",
    lowPerformance: "Bajo Rendimiento",
    communicationChannels: "Canales de Comunicación",
    subject: "Asunto",
    enterSubject: "Introduce el asunto del mensaje...",
    message: "Mensaje",
    writeMessage: "Escribe tu mensaje aquí...",
    characters: "caracteres",
    smsSegments: "Segmentos SMS",
    sendMessage: "Enviar Mensaje",
    saveAsDraft: "Guardar como Borrador",
    messageSent: "Mensaje Enviado",
    messageSentDesc: "Mensaje enviado a los miembros seleccionados correctamente",
    communicationHistory: "Historial de Comunicaciones",
    recipients: "destinatarios",
    delivered: "entregado",
    messageTemplates: "Plantillas de Mensajes",
    useTemplate: "Usar Plantilla",
    communicationAnalytics: "Analítica de Comunicaciones",
    totalSent: "Total Enviados",
    opened: "Abiertos",
    replied: "Respondidos",

    // Financial Dashboard
    revenueProjection: "Proyección de Ingresos",
    estimatedAnnualRevenue: "Ingresos anuales estimados",
    vsLastYear: "vs año anterior",
    revenuePerMember: "Ingresos por Miembro",
    averagePerMember: "Promedio por miembro",
    members: "miembros",
    revenuePerHectare: "Ingresos por Hectárea",
    perHectareManaged: "Por hectárea gestionada",
    haTotal: "ha total",
    serviceRevenue: "Ingresos por Servicios",
    fromSharedServices: "De servicios compartidos",
    margin: "margen",
    revenueStreams: "Flujos de Ingresos",
    agriculturalProduction: "Producción Agrícola",
    ofTotalRevenue: "del ingreso total",
    sharedEquipmentServices: "Servicios de Equipamiento Compartido",
    bulkPurchasingMargin: "Margen de Compras al Por Mayor",
    technicalAdvisory: "Asesoría Técnica",
    operatingCosts: "Costes Operativos",
    equipmentMaintenance: "Mantenimiento de Equipos",
    staffSalaries: "Salarios del Personal",
    administrative: "Administrativo",
    marketing: "Marketing",
    totalOperatingCosts: "Costes Operativos Totales",
    financialHealth: "Salud Financiera",
    grossRevenue: "Ingresos Brutos",
    netProfit: "Beneficio Neto",
    profitMargin: "Margen de Beneficio",

    // Group Insurance
    activePolicies: "Pólizas Activas",
    groupInsurancePolicies: "Pólizas de seguro grupal",
    totalCoverage: "Cobertura Total",
    insuredAmount: "Cantidad asegurada",
    insuredMembers: "Miembros Asegurados",
    coveredFarmers: "Agricultores cubiertos",
    lossRatio: "Ratio de Siniestralidad",
    claimsVsPremiums: "Reclamaciones vs primas",
    riskPortfolio: "Diversificación del Portafolio de Riesgo",
    droughtCoverage: "Cobertura de Sequía",
    excessRain: "Exceso de Lluvia",
    frostProtection: "Protección contra Heladas",
    multiPeril: "Multi-Riesgo",
    groupInsurancePoliciesTitle: "Pólizas de Seguro Grupal",
    newPolicy: "Nueva Póliza",
    loadingPolicies: "Cargando pólizas...",
    noPoliciesFound: "No se encontraron pólizas de seguro grupal.",
    createFirstPolicy: "Crear Primera Póliza",
    coverage: "Cobertura",
    premium: "Prima",
    period: "Período",
    recentClaimsActivity: "Actividad de Reclamaciones Reciente",
    pendingClaims: "Reclamaciones Pendientes",
    approvedThisMonth: "Aprobadas (Este Mes)",
    totalPayoutThisMonth: "Pago Total (Este Mes)",
    avgProcessingTime: "Tiempo Promedio de Procesamiento",
    premiumCollection: "Cobro de Primas",
    totalPremiumPool: "Pool Total de Primas",
    collected: "Cobrado",
    pending: "Pendiente",
    collectionRate: "Tasa de Cobro",

    // Market Intelligence
    trackedCommodities: "Commodities Rastreados",
    activePriceFeeds: "Feeds de precios activos",
    bullishForecasts: "Pronósticos Alcistas",
    expectedPriceIncreases: "Aumentos de precio esperados",
    marketSources: "Fuentes de Mercado",
    dataProviders: "Proveedores de datos",
    currentPrices: "Precios Actuales",
    priceForecasts: "Pronósticos de Precios",
    exportOpportunities: "Oportunidades de Exportación",
    realTimePrices: "Precios de Commodities en Tiempo Real",
    loadingPrices: "Cargando precios...",
    noPriceData: "No hay datos de precios disponibles. Conecta feeds de precios.",
    lastUpdated: "Última actualización",
    marketForecasts: "Pronósticos y Tendencias de Mercado",
    loadingForecasts: "Cargando pronósticos...",
    noForecastData: "No hay datos de pronóstico disponibles.",
    confidence: "confianza",
    forecast: "pronóstico",
    currentPrice: "Precio Actual",
    forecastMin: "Pronóstico Mín",
    forecastMax: "Pronóstico Máx",
    priceAlerts: "Alertas de Precios y Notificaciones",

    // Regional Benchmark
    regionalComparison: "Comparación Regional",
    cooperativesInRegion: "cooperativas en la región",
    averageNdvi: "NDVI Promedio",
    regionalAvg: "Prom. regional",
    areaPerMember: "Área por Miembro",
    regionalRanking: "Ranking Regional",
    overallRanking: "Ranking General",
    basedOnMetrics: "Basado en múltiples métricas de rendimiento",
    outOf: "de",
    ndviRanking: "Ranking NDVI",
    efficiencyRanking: "Ranking de Eficiencia",
    growthRanking: "Ranking de Crecimiento",
    sustainabilityRanking: "Ranking de Sostenibilidad",
    keyInsights: "Información Clave",

    // Reports Generator
    reportTemplates: "Plantillas de Informes",
    generate: "Generar",
    schedule: "Programar",
    recentReports: "Informes Recientes",
    scheduledReports: "Informes Programados",
    nextRun: "Próxima ejecución",
    edit: "Editar",
    dataExport: "Exportar Datos",
    exportMemberData: "Exportar Datos de Miembros",
    exportParcelAnalytics: "Exportar Analítica de Parcelas",
    exportFinancialData: "Exportar Datos Financieros",
    generatingReport: "Generando Informe",
    reportBeingGenerated: "Tu informe se está generando...",
    reportGenerated: "Informe Generado",
    reportGeneratedDesc: "Tu informe se ha generado correctamente",
    reportScheduled: "Informe Programado",
    reportScheduledDesc: "El informe se generará y enviará automáticamente en la fecha programada",

    // Role Management
    roleManagement: "Gestión de Roles",
    managers: "Gerentes",
    financial: "Financiero",
    technical: "Técnico",
    loadingRoles: "Cargando roles...",
    noUsersFound: "No se encontraron usuarios",
    cancel: "Cancelar",
    roleUpdated: "Rol Actualizado",
    roleUpdatedDesc: "El rol del usuario se ha actualizado correctamente",
    permissionsMatrix: "Matriz de Permisos",
    permission: "Permiso",
    manager: "Gerente",
    viewAllData: "Ver Todos los Datos",
    manageMembers: "Gestionar Miembros",
    manageFinancial: "Gestionar Finanzas",
    manageTechnical: "Gestionar Técnico",
    sendCommunications: "Enviar Comunicaciones",
    manageInsurance: "Gestionar Seguros",
    viewFinancial: "Ver Finanzas",
    fullAccess: "Acceso completo a todas las funciones de la cooperativa",
    manageFinancialDesc: "Gestionar datos financieros y seguros",
    manageTechnicalDesc: "Gestionar aspectos técnicos y comunicaciones",
    viewOnly: "Ver información de la cooperativa solamente"
  }
};